import styled from 'vue-styled-components';
import COLORS from '@design/colors.js';

export const Toast = styled('div', { isError: Boolean })`
    top: -1200px;
    width: 100%;
    height: 64px;
    position: fixed;
    background: ${({ isError }) =>
        isError ? COLORS['red-60'] : COLORS['blue-80']};
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    vertical-align: middle;
    color: #fff;
    line-height: 64px;
    opacity: 1;
    z-index: 100;
    top: 0;
    &.above {
        top: 0;
    }
    &.below {
    }
`;
